import { buildApiUrl } from '../config';
import useAPI from '../../hooks/useAPI';
import { useState } from 'react';
import { z } from 'zod';

// Import existing types to use in function signatures
import { AddExistingContactsToProjectRequest } from '../../types/backendRequests/AddExistingContactsToProjectRequest';
import { AddExistingContactsToProjectRequestSchema } from '../schemas/projectContactSchemas';

/**
 * Hook for adding existing contacts to project with built-in state management
 * Includes Zod validation for type safety
 */
export const useAddExistingContactsToProject = () => {
  const { callAPI } = useAPI({ method: 'PUT' });

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<any>(null);

  /**
   * Add existing contacts to project
   * @param requestData - The request data
   * @returns Promise with boolean indicating success
   */
  const action = async (requestData: AddExistingContactsToProjectRequest): Promise<boolean> => {
    setIsLoading(true);
    setError(null);
    try {
      // Validate the request data
      const validatedRequest =
        /* AddExistingContactsToProjectRequestSchema.parse( */ requestData; /* ) */

      await callAPI(buildApiUrl('project/existingContacts'), validatedRequest);
      return true;
    } catch (error) {
      console.error('Error in useAddExistingContactsToProject:', error);
      setError(error);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    error,
    action,
  };
};
